/**
 * Slide annotation types
 * @constant
 */
const ANNOTATION_TYPES = {
  AI: 'AI',
}

export default ANNOTATION_TYPES
